import { z } from 'zod'

export const legacyParkingPaymentMethodRequestSchema = z.object({
  customer_uid: z.string(),
  merchant_uid: z.string(),
  purchase_order_id: z.string().min(1).optional(),
  payment_method: z.enum(['CARD', 'KAKAO', 'NAVER', 'TOSS']).optional(),
  amount: z.number(),
  currency: z.string().optional().default('KRW'),
  merchant_name: z.string(),
  buyer_name: z.string(),
  buyer_tel: z.string(),
  custom_data: z.object({
    user_id: z.string(),
    subscribe_id: z.string(),
    product_id: z.string().optional(),
    purchase_order_id: z.string().min(1).optional(),
    tutor_connect_id: z.string().optional(),
    coupon_id: z.string().nullable(),
    is_v2_validated: z.boolean().optional(),
  }),
  notice_url: z.string().url(),
})

export const parkingPaymentMethodRequestSchema = legacyParkingPaymentMethodRequestSchema
  .extend({
    customer_uid: z.string().optional(),
    issue_id: z.string().min(1).optional(),
    customer_id: z.string().min(1).optional(),
  })
  .superRefine((request, ctx) => {
    // A PODO merchant ID alone is still legacy. Prepared PODO requests carry an explicit order marker.
    const prepared =
      request.merchant_uid.startsWith('KR_P_') || request.purchase_order_id || request.custom_data.purchase_order_id
    if (!prepared && request.customer_uid === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['customer_uid'],
        message: 'Customer UID is required for legacy payment',
      })
    }
  })

export type ParkingPaymentMethodRequest = z.infer<typeof legacyParkingPaymentMethodRequestSchema>
export type ParkingPaymentMethodRequestBody = z.infer<typeof parkingPaymentMethodRequestSchema>
